export const SET_IMPRESE = 'SET_IMPRESE';
export const SET_IMPRESE_PAGEABLE = 'SET_IMPRESE_PAGEABLE';
